var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedMeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4A38A;}\n\t.st1{fill:#FFD881;}\n\t.st2{fill:#9F1921;}\n\t.st3{fill:#FEE7B6;}\n\t.st4{fill:#E5E6E7;}\n\t.st5{fill:#A5A8AB;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.86,184.22c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C26.57,149.93,61.17,184.22,103.86,184.22"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.98,85.24c-28.78,0-54.35,11.07-54.35,28.78c0,13.28,12.79,24.35,31.97,24.35 c11.04,0,22.74-6.67,31.1-6.67c0.29,0,0.58,0.01,0.87,0.03c12.5,0.75,12.79,11.07,28.78,11.07c7.48,0,15.99-6.64,15.99-22.14 C157.33,100.74,134.95,85.24,102.98,85.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.62,101.23h6.39v12.79h-6.39V101.23z M150.94,107.62h6.4v12.79h-6.4V107.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141.35,127.79c-7.26,0-10.49-2.41-14.24-5.21c-3.42-2.55-7.29-5.43-14.25-5.85 c-0.38-0.02-0.77-0.03-1.15-0.03c-4.58,0-9.52,1.55-14.75,3.18c-5.47,1.71-11.13,3.48-16.35,3.48c-16.67,0-28.78-9.31-28.78-22.13 c0-17.25,26.36-26.56,51.16-26.56c29.64,0,51.16,13.96,51.16,33.2C154.14,122.48,146.48,127.79,141.35,127.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M102.98,76.88c27.79,0,47.96,13.03,47.96,30.99c0,13.25-6.59,17.71-9.59,17.71c-5.86,0-8.26-1.79-11.9-4.5 c-3.62-2.7-8.13-6.06-16.32-6.55c-0.47-0.03-0.95-0.04-1.43-0.04c-5.27,0-10.52,1.64-16.07,3.38c-5.16,1.62-10.5,3.29-15.03,3.29 c-12.71,0-25.58-6.84-25.58-19.92C55.02,85.41,79.73,76.88,102.98,76.88 M102.98,72.45c-28.78,0-54.35,11.07-54.35,28.78 c0,13.28,12.79,24.35,31.97,24.35c11.04,0,22.74-6.67,31.1-6.67c0.29,0,0.58,0.01,0.87,0.03c12.5,0.75,12.79,11.07,28.78,11.07 c7.48,0,15.99-6.64,15.99-22.14C157.33,87.95,134.95,72.45,102.98,72.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M97.1,77.07c0,0,9.08-0.19,15.48,4.24c3.2,2.22,1.07,7.19,1.07,7.19l5.32,1.66c0,0-0.2-2.67,9.59-4.43 c7.19-1.29,14.52,4.43,14.52,4.43s-8.13-11.07-24.11-13.28C102.98,74.67,97.1,77.07,97.1,77.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M125.36,94.59c0,4.89-5.73,8.86-12.79,8.86c-7.06,0-12.79-3.97-12.79-8.86c0-4.89,5.73-8.86,12.79-8.86 C119.63,85.73,125.36,89.7,125.36,94.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M118.97,94.59c0,2.45-2.86,4.43-6.39,4.43c-3.53,0-6.4-1.98-6.4-4.43s2.86-4.42,6.4-4.42 C116.1,90.16,118.97,92.14,118.97,94.59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedMeat);
export default __webpack_public_path__ + "static/media/Red_meat.08dd0c1be2a00588eddd027639d139d7.svg";
export { ForwardRef as ReactComponent };